import Dce from "dce-engine/lib/decorators/Dce";
import {DceComponent, DceEngine} from "dce-engine";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import {AjaxBlock} from "../../index";
import {DceWebSocketConnection, DceWebSocketIncomingMessage, DceWebSocketSubscribeHandle} from "dce-websocket";

interface WSRefreshProps {
    channel: string,
    url: string
}

@Dce("WSRefresh")
export default class WSRefresh extends DceComponent<WSRefreshProps> {

    private subHandle: DceWebSocketSubscribeHandle;
    private ajaxBlock: AjaxBlock;

    constructor(elem: DceHTMLElement, props: WSRefreshProps | null) {
        super(elem, props);

        this.subHandle = DceWebSocketConnection.getInstance()
            .subscribe(this.props.channel, (msg) => {
                this.onMessage(msg);
            });

    }

    onMessage(msg: DceWebSocketIncomingMessage): void {

        if (null == this.ajaxBlock) {
            this.ajaxBlock = DceEngine.getInstance().addComponentsOnElement(this.elem, "AjaxBlock", {
                url: this.props.url,
                replace: true
            });
        }

        this.ajaxBlock.refresh(() => {
            console.log("Refresh: ", this.elem);
        });
    }

    onRemove() {
        DceWebSocketConnection.getInstance().unsubscribe(this.subHandle);
    }
}